module.exports = __webpack_public_path__ + "img/Gefahr_durch_Gas.d25bad63.svg";